/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useMemo, useState } from "react";
import { Else, If, Then } from "react-if";
import { Table } from "@nordcloud/gnui";
import { NoData, Pagination } from "~/components";
import { isEmpty } from "~/tools";
import { ResourceWithSelectionMethod } from "../../../types";
import { ResourceRow } from "./ResourceRow";

type Props = {
  resources?: ResourceWithSelectionMethod[];
};

export function ResourcesTable({ resources }: Props) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);

  const paginatedGroups = useMemo(
    () => (resources ?? []).slice((page - 1) * limit, page * limit),
    [resources, page, limit]
  );

  return (
    <>
      <If condition={isEmpty(resources ?? "")}>
        <Then>
          <NoData hasIcon message="There are no Resources." />
        </Then>
        <Else>
          <Table hoverline striped>
            <Table.thead>
              <Table.tr>
                <Table.th css={{ width: "2%" }} />
                <Table.th>Resource Name/Type </Table.th>
              </Table.tr>
            </Table.thead>
            <Table.tbody>
              {paginatedGroups.map((resource) => (
                <ResourceRow
                  key={`${resource.id}-${resource.selectionMethod}`}
                  resource={resource}
                />
              ))}
            </Table.tbody>
          </Table>
          <Pagination
            count={resources?.length ?? 0}
            page={page}
            limit={limit}
            onPageChange={setPage}
            onLimitChange={setLimit}
          />
        </Else>
      </If>
    </>
  );
}
